import React from "react";
import Navbar from "../components/Navbar";

const Home = () => {
    return (
        <div>
            <Navbar/>
            <h1>HOME</h1>
        </div>
    );
};

export default Home;
